/**
 * G3-1 决策归因文案 (UX_REWORK_PLAN_2026-07-14 §G3).
 *
 * Shared between the home last-game hero (LeagueDashboard) and the gameLog
 * postgame recap card so both surfaces render the identical in-game voice line.
 * The worker derives the structured attribution (common/gameAttribution.ts);
 * this module only maps it to an i18n variant + English default. Kept pure (no
 * i18n / getCol) so the stat text is formatted at the call site with the view's
 * localized stat columns, and so mobileG3Attribution.test can assert the
 * en/zh JSON stays in lock-step with GAME_ATTRIBUTION_DEFAULTS.
 */

export type GameAttributionData = {
	type: "trade" | "freeAgent";
	name: string;
	debut: boolean;
	stats: { stat: string; value: number }[];
};

export type GameAttributionVariant =
	| "trade"
	| "tradeDebut"
	| "freeAgent"
	| "freeAgentDebut";

// English source strings. Every locale key (leagueDashboard.attribution.* and
// gameLog.attribution.*) mirrors these, so they double as i18n defaultValues.
export const GAME_ATTRIBUTION_DEFAULTS: Record<GameAttributionVariant, string> = {
	trade: "{{name}}, who you traded for, put up {{stats}}",
	tradeDebut: "{{name}}, your trade pickup, debuted with {{stats}}",
	freeAgent: "{{name}}, who you signed, put up {{stats}}",
	freeAgentDebut: "{{name}}, your signing, debuted with {{stats}}",
};

export const getGameAttributionVariant = (
	attribution: Pick<GameAttributionData, "type" | "debut">,
): GameAttributionVariant =>
	`${attribution.type}${attribution.debut ? "Debut" : ""}` as GameAttributionVariant;
